/* Entity Intelligence shared constants + formatters (Figma contract values) */

export const EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const CHAIN_ACCENTS = ["#8b5cff", "#5d9bff", "#22d3ee", "#f0445e"];
export const DONUT_COLORS = ["#8b5cff", "#4c8dff", "#22d3ee", "#f0445e"];
export const OTHER_COLOR = "#4c4c61";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const fmtUsd = (n?: number | null): string => {
  if (n == null || !isFinite(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (abs >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `$${(n / 1e6).toFixed(0)}M`;
  if (abs >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n.toFixed(2)}`;
};

export const fmtPct = (n?: number | null, digits = 2): string => {
  if (n == null || !isFinite(n)) return "—";
  return `${n >= 0 ? "+" : "−"}${Math.abs(n).toFixed(digits)}%`;
};

export const pctColor = (n?: number | null, lower = false): string => {
  if (n == null) return "var(--nl-text-muted)";
  if (n >= 0) return lower ? "#1fe09c" : "#20c77a";
  return "#f0445e";
};

export const timeAgo = (iso?: string | null): string => {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 90) return "UPDATED JUST NOW";
  if (s < 3600) return `UPDATED ${Math.round(s / 60)}M AGO`;
  if (s < 86400) return `UPDATED ${Math.round(s / 3600)}H AGO`;
  return `UPDATED ${Math.round(s / 86400)}D AGO`;
};

export const trackedSince = (iso?: string | null): string => {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00Z");
  return d.toLocaleDateString("en-US", { month: "long", year: "numeric", timeZone: "UTC" }).toUpperCase();
};

export const protocolAssetUrl = (slug: string) => `${API_BASE}/api/v1/assets/protocol/${slug}`;
export const entityAssetUrl = (etype: string, slug: string) => `${API_BASE}/api/v1/assets/${etype}/${slug}`;
